//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
export default {
  name: 'DigitalReceipt',
  components: {},
  data: function data() {
    return {
      // TODO: Replace with suitable data
      openEmail: false,
      email: '',
      location: '22 Friary St, Guildford GU1 4EH',
      name: 'Thaikhun Guildford',
      ss: {},
      server: 'Tim Smith',
      tableNumber: 13,
      totalPrice: '34.45',
      receipt: [{
        id: 1,
        title: 'Mains',
        items: [{
          id: 11,
          count: 1,
          price: '10.12',
          name: 'Pad thai curry'
        }, {
          id: 12,
          count: 1,
          price: '8.15',
          name: 'Prawn curry'
        }, {
          id: 13,
          count: 1,
          price: '1.05',
          name: 'Extra cheese'
        }]
      }, {
        id: 2,
        title: 'Drinks',
        items: [{
          id: 21,
          count: 2,
          price: '3.5',
          name: 'White wine'
        }, {
          id: 22,
          count: 2,
          price: '4.07',
          name: 'Coca Cola'
        }]
      }]
    };
  },
  computed: {
    logoRestaurant: get('theme/logo')
  },
  methods: {
    onSubmit: function onSubmit() {//? Whats the point of calling this function?
    }
  }
};